import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsRabbitmqComponent } from './simple-icons-rabbitmq.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsRabbitmqComponent ],
    exports:      [ SimpleIconsRabbitmqComponent ],
    bootstrap:    []
})
export class SimpleIconsRabbitmqModule {}
